import { render, staticRenderFns } from "./Unsupported.vue?vue&type=template&id=181ef76a&scoped=true&"
import script from "./Unsupported.vue?vue&type=script&lang=js&"
export * from "./Unsupported.vue?vue&type=script&lang=js&"
import style0 from "./Unsupported.vue?vue&type=style&index=0&id=181ef76a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181ef76a",
  null
  
)

export default component.exports